<template>
    <div class="card action-card card-img-holder cursor-pointer text-white"
         :class="[hovered || isSelected ? 'bg-gradient-primary shadow-sm' : 'bg-gradient-dark ']"
         @mouseenter="hover(true)" @mouseleave="hover(false)"
         @click="select()"
    >
        <div class="card-body p-3">
            <img src="images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image">
            <h3 class="mt-2">
                {{ title }}
                <i class="mdi mdi-36px float-right" :class="icon"></i>
            </h3>
        </div>
    </div>
</template>

<script>
export default {
    name: "GymViewMode",
    data: () => ({
       hovered: false,
    }),
    methods: {
      select() {
          this.$emit('update:selected', this.mode);
      },
      hover(isHovered) {
          this.hovered = isHovered;
          this.$emit('hover', isHovered);
      }
    },
    computed: {
        isSelected() {
            return this.selected === this.mode;
        }
    },
    props: {
        title: {type: String, required: true},
        mode: {type: String, required: true},
        icon: {type: String, required: true},
        selected: {type: String, required: true},
    }
}
</script>

<style scoped>

</style>
